<template>
    <div>
        <p class="font-weight-bold text-center">📢 PROCESSO SELETIVO SIMPLIFICADO – INVEST MT</p>
        <p>
            A Agência Mato-Grossense de Promoção de Investimentos e Competitividade informa aos candidatos inscritos no Processo Seletivo Simplificado nº 001/2025 que a prova objetiva (Etapa 3) já tem data, horário e local definidos.
        </p>
        <p>
            📍 <strong>Local:</strong> Escola Estadual Victorino Monteiro da Silva<br/>Rua I, s/n – Bairro Ilza Terezinha Picolli Pagot – Cuiabá/MT
        </p>
        <p>
            <strong>PERÍODO/ PRAZO PARA ENVIO DAS PROPOSTAS:</strong> de 23/02/2026 até 25/02/2026, às 23h59min (horário
            de Cuiabá/MT).
        </p>
        <p>
            📅 <strong>Data:</strong> 08 de março de 2026 (domingo)
        </p>
        <p>
            ⏰ <strong>Horários (Cuiabá/MT):</strong> <ul>
                <li>Abertura dos portões: 07h30</li>
                <li>Fechamento dos portões: 08h30</li>
                <li>Início da prova: 09h00</li>
                <li>Encerramento: 12h00</li>
            </ul>
        </p>
        <p>
            Reforçamos a importância de atenção aos horários e organização prévia para garantir uma participação tranquila nesta etapa do certame.
        </p>
        <div class="d-block text-center mt-3">
            <b-button pill variant="outline-info" @click="closeModal">Fechar</b-button>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        closeModal() {
            this.$emit('closeModal');
        }
    }
};
</script>
<style scoped></style>